import { useQuery } from '@tanstack/react-query'
import { isUserLanguage, type UserLanguage } from 'shared/lib/i18n'
import type { OfferDocument } from './types'

/** The offer is a long legal text, so each language is a separate chunk. */
const OFFER_LOADERS: Record<UserLanguage, () => Promise<{ default: OfferDocument }>> = {
	ru: () => import('./offer.ru'),
	uz: () => import('./offer.uz'),
}

export function useOfferDocument(language: string, enabled: boolean) {
	const resolved: UserLanguage = isUserLanguage(language) ? language : 'ru'

	return useQuery({
		queryKey: ['public-offer', resolved],
		queryFn: async () => (await OFFER_LOADERS[resolved]()).default,
		enabled,
		staleTime: Infinity,
		gcTime: Infinity,
	})
}
